<template>
    <div class="c-algolia-search__form c-site-search__form">
        
        <div class="c-algolia-search__field">
            <label class="c-algolia-search__label" for="keywords">Keywords</label>
            <input
                v-model="searchText"
                type="text"
                class="c-algolia-search__input"
                placeholder="Keywords"
                v-on:keyup.enter="search"
                v-on:input="inputSearchText"
            />
        </div>

        <div class="c-algolia-search__field">
            <label class="c-algolia-search__label">Types</label>
            <div class="c-algolia-search__checkboxes">
                <label
                    v-for="(value, key) in categoryList"
                    :key="value"
                    class="c-algolia-search__checkbox-label"
                >
                    <input
                        type="checkbox"
                        :value="key"
                        v-model="selectedCategories"
                        @change="search"
                        :checked="selectedCategories.includes(key)"
                    />
                    {{ value }}
                </label>
            </div>
        </div>

        <!-- <div class="c-algolia-search__field">
            <label class="c-algolia-search__label" for="publishedAfter">Published after</label>
            <input 
                class="c-algolia-search__input"
                type="date" 
                id="publishedAfter"
                v-model="publishedAfter" 
                @change="search" />
        </div>

        <div class="c-algolia-search__field">
            <label class="c-algolia-search__label" for="publishedBefore">Published before</label>
            <input 
                class="c-algolia-search__input"
                type="date" 
                id="publishedBefore"
                v-model="publishedBefore" 
                @change="search" />
        </div> -->

        <div class="c-algolia-search__field">
            <label class="c-algolia-search__label" for="sort">Sort by</label>
            <select v-model="sort" id="sort" @change="search" class="c-algolia-search__select">
                <option value="">Relevance</option>
                <option value="newest">Newest</option>
                <option value="oldest">Oldest</option>
            </select>
        </div>

        <button class="u-button" @click="search">
            Search
        </button>

        <button class="c-algolia-search__reset" @click="resetSearchFilters">Reset</button>
        
    </div>
</template>


<script>
import { mapFields } from "vuex-map-fields";

export default {
    data() {
        return {};
    },
    components: {},
    mounted() {
        this.setStateBasedOnUrlParameters();

        if (!this.category && this.categoryList.length > 0) {
            this.category = this.categoryList[0];
        } 
    },
    computed: {
        ...mapFields([
            "searchApp.state.loading",
            "searchApp.state.hasSearched",

            "searchApp.search.searchText",
            "searchApp.search.selectedCategories",
            "searchApp.search.publishedAfter",
            "searchApp.search.publishedBefore",
            "searchApp.search.sort",
            "searchApp.search.start",

            "searchApp.searchOptions.categoryList",
        ]),
    },
    watch: {},
    methods: {
        resetFilters() {
            this.sort = "";
        },
        inputSearchText() {
            // We want to reset the sort back to relevant on textchange
            this.sort = "";
        },
        // Set state of filters and search based on url parameters
        setStateBasedOnUrlParameters() {
            let url = new URL(window.location.href);
            let params = new URLSearchParams(url.search);
            let shouldSearch = false;

            const paramNames = ["selectedCategories", "sort", "searchText"];

            //only set param if the param is present in the url otherwise leave as the default value
            for (const paramName of paramNames) {
                const paramValue = params.get(paramName);
                if (paramValue || paramValue === "") {
                    if (paramName === "selectedCategories") {
                        // Split comma-separated string into an array
                        this.selectedCategories = paramValue
                            .split(",")
                            .map(s => s.trim())
                            .filter(Boolean); // remove empty strings

                    } else {
                        this[paramName] = paramValue;
                    }

                    shouldSearch = true;
                    console.log("set params", paramName, paramValue);
                }
            }

            if (shouldSearch) {
                this.search();
            }
        },
        search() {

            // --------- toggle categories
            
            // If 'All' is selected along with other categories, remove 'All'
            if (this.selectedCategories.includes('All') && this.selectedCategories.length > 1) {
                this.selectedCategories = this.selectedCategories.filter(c => c !== 'All');
            }

            // If nothing is selected, default back to 'All'
            if (this.selectedCategories.length === 0) {
                this.selectedCategories = ['All'];
            }

            // ----------- trigger search

            this.start = 0;
            this.$store.dispatch("submitSearch");
        },
        resetSearchFilters() {
            this.$store.dispatch("resetSearch");
        },
    },
};
</script>

<style lang="scss"></style>
